import { connect } from 'react-redux'
import React, { Component } from 'react'
import { createAction } from 'redux-actions'
import VideoItem from './videoItem/VideoItem'
import VideoListHeader from './VideoListHeader'
import { browserHistory, Link } from 'react-router'
import VideoCreator from './VideoCreator'
import Pagination from '../../misc/Pagination'
import { fetchVideos, SELECT, DESELECT, DESELECT_ALL, ZOOM } from '../../actions'
import './videoList.css'
import { isMobile, isIOs, getVideosAndPending, getAllShortcodes } from '../../misc/selectors'
import AnimatedLogo from '../../assets/logo.gif'
import debounce from 'lodash/debounce'
import ZoomOverlay from './ZoomOverlay'
import { Helmet } from "react-helmet";
import MdClear from 'react-icons/lib/md/clear'
import { setCookie } from '../../misc/utilities'
import Cookies from 'js-cookie'

const mapStateToProps = (state, ownProps) => {
  const { videos, me } = state
  const { query } = ownProps

  return {
    query,
    me,
    isIOs: isIOs(state),
    pro: me.pro,
    selected: me.selected,
    pages: Math.ceil(videos.total / videos.count),
    // don't return uploads on albums because we don't know which album they're in
    items: getVideosAndPending(state),
    isFetching: videos.isFetching,
    isMobile: isMobile(state),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  select: (shortcode) => {
    dispatch(createAction(SELECT)(shortcode))
  },
  deselect: (shortcode) => {
    dispatch(createAction(DESELECT)(shortcode))
  },
  deselectAll: (shortcode) => {
    dispatch(createAction(DESELECT_ALL)(shortcode))
  },
  closeZoom: () => {
    dispatch(createAction(ZOOM)())
  },
})

class VideosList extends Component {
  constructor() {
    super()
    this.state = {
      sort: 'date_added',
      sortd: 'DESC',
      count: 12,
      page: 1,
      search: null,
      playerMuted: true,
      currentSearch: null,
      canShowWelcome: false,
    }

    this.dispatchFetch = this.dispatchFetch.bind(this)
    this.dispatchFetchDebounced = debounce(this.dispatchFetch, 500, { leading: true, trailing: true })
  }

  dispatchFetch(options) {
    this.setState({ currentSearch: options.search })
    this.props.dispatch(fetchVideos(options))
  }

  fetch(options = {}, force = false, debounced = false) {
    const processedOptions = {
      ...this.state,
      ...options,
      force,
    }

    this.setState(options)
    if (debounced) {
      this.dispatchFetchDebounced(processedOptions)
    } else {
      this.dispatchFetch(processedOptions)
    }
  }

  componentDidMount() {
    this.fetch()

    setTimeout(() => {
      this.setState({ canShowWelcome: true })
    }, 500)
  }

  isSelected(video) {
    return this.props.selected.contains(video.shortcode)
  }

  render() {
    const { me, query } = this.props
    return (
      <div>
        <Helmet>
          <title>Dashboard - Streamable</title>
          <meta name="description" content="Upload, edit, and manage your video library."></meta>
          <link rel="canonical" href="https://streamable.com/videos" />
        </Helmet>
        <div className="videos-list">
          <VideoCreator />
          {query.alert ?
            <div className="alert alert-info">
              {query.alert == 'downgrade' ? 'Downgrade successful. ' : query.alert == 'upgrade' ? 'Upgrade successful. ' : ''}You're now on the <Link to="/settings">{me.plan_name}</Link> plan. 
              <div onClick={() => browserHistory.push('/videos')} style={{'float': 'right', cursor: 'pointer'}}>Hide</div>
            </div>
          : ''}
          {me.stale && !Cookies.get('hideStaleNotification') ?
            <div className="alert alert-warning">
              You have {me.stale} video{me.stale > 1 ? 's' : ''} that will be deleted soon. 
              <a 
                href="/pricing"
                style={{"marginLeft": '5px'}}
                onClick={(e) => {
                  browserHistory.push('/pricing?src_internal=dashboard-stale-notification')
                  e.preventDefault();
                }}>
                  Upgrade Now
              </a> 
              <a 
                href=""
                onClick={(e) => {
                  setCookie('hideStaleNotification', 'true', 90000); 
                  this.setState({ hideStaleNotification: true })
                  e.preventDefault();
                }} 
                style={{float: 'right'}}>
                  Dismiss
              </a>
            </div>
          : ''}
          <VideoListHeader
            onChange={() => this.fetch({}, true)}
            onSearchChanged={(search) => {
              this.fetch({ search }, false, true)
            }}
            onSortChanged={(sort, sortd) => {
              this.fetch({ sort, sortd })
            }}
            {...this.props}
            {...this.state}
          />
          <div
            className={
              `grid row videos-list-items ${this.props.items.length ? '' : 'empty'}`
            }
          >
            {this.props.items.map((video, i) => (
              <VideoItem
                me={this.props.me}
                key={video.shortcode || video.local_id}
                selectableKey={video.shortcode || video.local_id}
                type='grid'
                video={video}
                selected={this.isSelected(video)}
                onSelect={() => {
                  this.props.select(video.shortcode || video.local_id)
                }}
                onDeselect={() => {
                  this.props.deselect(video.shortcode || video.local_id)
                }}
                isMobile={isMobile}
              />
            ))}
          </div>
          {this.props.isFetching === false && !this.props.items.length && this.state.currentSearch === this.state.search
            ? this.state.currentSearch
                ?
                  <div className="video-list-placeholder">No videos match your search</div>
                :
                  this.state.canShowWelcome ?
                    <div className="row video-list-placeholder-container">
                      <div className="video-list-placeholder">
                        <div className="embed-container card">
                          <div
                            style={{
                              width: '100%',
                              minHeight: '300px',
                              position: 'relative',
                              paddingBottom: '56.250%',
                            }}
                          >
                            <iframe
                              src="//streamable.com/e/bwkxc"
                              frameBorder="0"
                              allowFullscreen
                              webkitallowfullscreen
                              mozallowfullscreen
                              scrolling="no"
                              style={{
                                width: '100%',
                                height: '100%',
                                position: 'absolute',
                                left: '0px',
                              }}
                            />
                          </div>
                        </div>
                        <a href="" className="skip-tutorial" onClick={(e) => {
                          e.preventDefault();
                          this.setState({canShowWelcome: false})
                        }}>
                        <MdClear /> Close 
                        </a>
                      </div>
                      
                    </div>
                : ''
            : ''}
          {this.props.pages > 1
            ? <div className="col-12">
              <Pagination
                page={this.state.page}
                pages={this.props.pages}
                onChange={(page) => {
                  this.fetch({ page })
                }}
              />
            </div>
            : ''}
          {this.props.isFetching === true || this.state.currentSearch !== this.state.search
            ? <div className="loading-indicator">
              <img src={AnimatedLogo} alt="presentation" />
            </div>
            : ''}
          {this.props.me.zoomed
            ? 
              <ZoomOverlay
                me={this.props.me}
                video={this.props.me.zoomed}
                onClose={this.props.closeZoom}
                isMobile={this.props.isMobile}
              />
            : ''}
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VideosList)
